import { Box, Typography } from '@mui/material';
import { WaiverRequestWithCustomerAndEvents } from '../../../../types/waivers';
import { describeFormRow, FormRowContent } from './formRowContent';
import FormTableRow from './FormTableRow';

interface Props {
  waiverRequests: WaiverRequestWithCustomerAndEvents[];
  timezone: string;
  onView: (waiverRequest: WaiverRequestWithCustomerAndEvents) => void;
  onResend: (waiverRequest: WaiverRequestWithCustomerAndEvents) => void;
}

interface FormRow {
  waiverRequest: WaiverRequestWithCustomerAndEvents;
  content: FormRowContent;
}

function FormsTable({ waiverRequests, timezone, onView, onResend }: Props) {
  const rows = waiverRequests.reduce<FormRow[]>((acc, waiverRequest) => {
    const content = describeFormRow(waiverRequest, timezone);
    if (content) acc.push({ waiverRequest, content });
    return acc;
  }, []);

  if (rows.length === 0) return null;

  return (
    <Box>
      <Typography
        variant="body2"
        sx={{ color: 'text.secondary', marginBottom: '4px' }}>
        Forms
      </Typography>
      {rows.map(({ waiverRequest, content }) => (
        <FormTableRow
          key={waiverRequest.id}
          content={content}
          onView={() => onView(waiverRequest)}
          onResend={() => onResend(waiverRequest)}
        />
      ))}
    </Box>
  );
}

export default FormsTable;
